import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7575d4df"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "nav-margin"
}, null, -1));
const _hoisted_2 = {
  class: "highlignt"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_button = _resolveComponent("van-button");
  const _component_van_search = _resolveComponent("van-search");
  const _component_van_cell = _resolveComponent("van-cell");
  const _component_ListViewCpt = _resolveComponent("ListViewCpt");
  const _component_PopupDatePickerCpt = _resolveComponent("PopupDatePickerCpt");
  const _component_PageNavBackLayoutCpt = _resolveComponent("PageNavBackLayoutCpt");
  return _openBlock(), _createBlock(_component_PageNavBackLayoutCpt, {
    class: "page"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_search, {
      modelValue: $data.searchForm.chnName,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.searchForm.chnName = $event),
      "show-action": "",
      placeholder: "输入客户名称",
      onSearch: $options.onSearch
    }, {
      action: _withCtx(() => [_createVNode(_component_van_button, {
        style: {
          "width": "100%"
        },
        type: "primary",
        size: "small",
        onClick: $options.onSearch,
        loading: $data.btnLoading
      }, {
        default: _withCtx(() => [_createTextVNode(" 查询 ")]),
        _: 1
      }, 8, ["onClick", "loading"])]),
      _: 1
    }, 8, ["modelValue", "onSearch"]), _createVNode(_component_ListViewCpt, {
      ref: "ListViewCpt",
      request: $data.listRequest,
      requestParameter: $data.searchForm,
      onOnListDataChange: $options.onListDataChange
    }, {
      default: _withCtx(({
        item
      }) => [_hoisted_1, _createVNode(_component_van_cell, {
        "arrow-direction": "",
        "is-link": "",
        to: '/work-wx/appoint/query/detail?item=' + JSON.stringify({
          appointmentId: item.id,
          agentId: item.agentId,
          productId: item.productId,
          customerId: item.customerId
        }),
        title: item.chnName
      }, {
        value: _withCtx(() => [_createElementVNode("span", {
          style: _normalizeStyle({
            color: $options.getStatusStyle(item.status)
          })
        }, _toDisplayString(_ctx.formatSelectColumn($data.codeResItems, 'status', {
          status: item.status
        })), 5)]),
        _: 2
      }, 1032, ["to", "title"]), _createVNode(_component_van_cell, {
        title: item.productName
      }, {
        label: _withCtx(() => [_createElementVNode("div", null, [_createTextVNode(" 剩余额度: "), _createElementVNode("span", _hoisted_2, _toDisplayString(item.amount), 1), _createTextVNode(" 元 ")]), _createElementVNode("div", null, "预约时间: " + _toDisplayString(item.createDate), 1), _createElementVNode("div", null, "失效时间: " + _toDisplayString(item.invalidDate), 1)]),
        _: 2
      }, 1032, ["title"])]),
      _: 1
    }, 8, ["request", "requestParameter", "onOnListDataChange"]), _createVNode(_component_PopupDatePickerCpt, {
      ref: "PopupDateTimeCpt",
      onOnSelectedChange: $options.onDateTimeSelectedChange
    }, null, 8, ["onOnSelectedChange"])]),
    _: 1
  });
}